import Benefit from './Benefit';
import Dilemma from './Dilemma';
import Pricing from './Pricing';
import ThreePromise from './ThreePromise';
import Witness from './Witness';

/**
 * 下方內容
 */
function Bottom() {
  return (
    <div className="w-full">
      <Pricing />

      <Dilemma />

      <ThreePromise />

      <Benefit />

      <Witness />
    </div>
  );
}

export default Bottom;
